import { formatZonedDate } from 'legacy/utils/date/formatZonedDate'
import { formatCityName } from 'legacy/utils/formatCityName'

function getLaneFromStops(stops) {
  const pickup = stops[0]
  const delivery = stops[stops.length - 1]
  const lane = `${formatCityName(pickup.city)}, ${pickup.state} → ${formatCityName(
    delivery.city
  )}, ${delivery.state}`

  const { window_start, timezone } = pickup
  const formattedDate = formatZonedDate(window_start, timezone, 'EEE, MMM d')
  return `${lane} - ${formattedDate}`
}

export { getLaneFromStops }
